import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { IAddressRegionDto, IBuildTypeDto } from '@classictechsolutions/hubapi-transpiled-enums';
import { LotMigratorAddressSectionComponent } from '../shared-sections/lot-migrator-address-section.component';
import { LotMigratorLotBuildSectionComponent } from '../shared-sections/lot-migrator-lot-build-section.component';

@Component({
    selector: 'cb-lot-migrator-block-form',
    standalone: true,
    imports: [
        MatDividerModule,
        LotMigratorAddressSectionComponent,
        LotMigratorLotBuildSectionComponent
    ],
    templateUrl: './lot-migrator-block-form.component.html',
    styleUrls: ['./lot-migrator-block-form.component.scss']
})
export class LotMigratorBlockFormComponent {
    @Input({ required: true }) public lotForm!: FormGroup;
    @Input() public addressRegions: IAddressRegionDto[] = [];
    @Input() public buildTypeOptions: IBuildTypeDto[] = [];
    @Input() public contractTypes: { id: number; label: string }[] = [];
    @Input() public lotTypes: { id: number; label: string }[] = [];
}
